import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificariComponent } from './notificari.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [NotificariComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [NotificariComponent]
})
export class NotificariModule { }
